import * as z from "zod";

import { fastumTicketSchema } from "./fastum-ticket";

export const fastumTicketIssueLinkSchema = z.object({
  identifier: z.number().int().positive(),
  title: z.string(),
});

export const fastumTicketWithIssuesSchema = fastumTicketSchema
  .extend({
    issues: z.array(fastumTicketIssueLinkSchema).default([]),
  })
  .transform((ticket) => ({
    ...ticket,
    linkedToIssue: ticket.issues.length > 0,
  }));

export const fastumTicketsWithIssuesSchema = z.array(fastumTicketWithIssuesSchema);

export type FastumTicketIssueLink = z.infer<typeof fastumTicketIssueLinkSchema>;
export type FastumTicketWithIssues = z.infer<typeof fastumTicketWithIssuesSchema>;
